import { FocusAreaSelectDropdown } from "@/domain/focus-area/components/focus-area-select-dropdown";
import { useGetFocusAreaList } from "@/domain/focus-area/hooks/api/use-get-focus-area-list";

import { SelectFieldProps } from "./select-field-props";
import { SingletonSelectField } from "./singleton-select-field";

export function FocusAreaSelectField({ workspaceId, value, onChange, disabled }: SelectFieldProps) {
  const { focusAreaList } = useGetFocusAreaList({ workspaceId });

  return (
    <SingletonSelectField
      value={value}
      disabled={disabled}
      optionList={focusAreaList}
      renderDropdown={({ value: dropdownValue, disabled: dropdownDisabled, children }) => (
        <FocusAreaSelectDropdown
          workspaceId={workspaceId}
          selected={dropdownValue ? { focusAreaId: dropdownValue } : undefined}
          onSelect={(focusArea) => onChange(focusArea ? focusArea.id : "")}
          isReadOnly={dropdownDisabled}
          asChild
        >
          {children}
        </FocusAreaSelectDropdown>
      )}
    />
  );
}
